var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "sw-model-material-analyzing-model\n    sw--position-relative\n    sw--overflow-hidden\n    sw-grid-flex\n    sw-grid-flex--align-center\n    sw--padding-hor-4\n    sw-dms--bg-grey-96\n    sw--border-transparent-1\n    sw--border-radius-3\n    sw--margin-bottom-1"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "sw-grid-flex sw-grid-flex--align-center sw-grid-flex__cell"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "sw-grid-flex__cell sw--position-relative sw-dms--color-grey-46 sw--margin-left-2"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "sw-model-material-analyzing-model__message-0"
                  },
                  [_vm._v("Analyzing 3D model")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sw-model-material-analyzing-model__message-1\n          sw--position-absolute\n          sw--vertical-center\n          sw--opacity-0"
                  },
                  [_vm._v("\n        Fixing your model for printing…\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sw-model-material-analyzing-model__message-2\n          sw--position-absolute\n          sw--vertical-center\n          sw--opacity-0"
                  },
                  [
                    _vm._v(
                      "\n        Your model is taking some extra time to fix…\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sw-model-material-analyzing-model__message-3\n        sw--position-absolute\n        sw--vertical-center\n        sw--opacity-0"
                  },
                  [
                    _vm._v(
                      "\n        Bear with us! Due to complexities in your model, it may take several more minutes to finalize...\n      "
                    )
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "sw-model-material-analyzing-model__animation-bar\n    sw--position-absolute\n    sw--position-left\n    sw--position-bottom\n    sw--border-radius-2"
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }